import { createFileRoute } from "@tanstack/react-router";

import { TransferPage } from "../../../../features/inventory/transfer-page";

export const Route = createFileRoute("/_app/inventory/transfers/$id")({ component: TransferRoute });

function TransferRoute() {
  const { id } = Route.useParams();
  return <TransferPage key={id} id={id} />;
}
